import styled from 'styled-components';

export const FilterWrapper = styled.div`
  min-width: 340px;
`;
